var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.event,{tag:"component",attrs:{"task":_vm.task},on:{"done":_vm.done}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }